<template>
    <b-row>
        <div class="d-flex mt-3">
            <img src="../../../../assets/Img/icons/downsymbol.svg" alt="" class="down-symbol">
            <h6 class="bold-heading mt6 ms-1">{{ $t('Grouping.title') }}</h6>
        </div>
    </b-row>
    <!-- {{ dataObj }} -->

    <b-row class="my-2 ps-3">
        <b-col sm="12" md="12" lg="12" xl="10">
            <b-row>
                <b-col lg="12" md="12" sm="12" cols="12" class="form-field-column">
                    <label class="display-field-label mb-2">{{ $t('Grouping.itemtype') }}</label>
                </b-col>
                <b-col lg="12" md="12" sm="12" cols="12" class="form-field-column mb-5">
                    <span class="details-circle-common"> {{ dataObj.ItemCategoryName }}</span>
                </b-col>
            </b-row>
            <b-row>
                <b-col lg="12" md="12" sm="12" cols="12" class="form-field-column">
                    <label class="display-field-label mb-2">{{ $t('Grouping.itemgroup') }}</label>
                </b-col>
                <b-col lg="12" md="12" sm="12" cols="12" class="form-field-column mb-5">
                    <span class="details-circle-common"> {{ dataObj.ItemGroupName }}</span>
                </b-col>
            </b-row>
            <b-row>
                <b-col lg="12" md="12" sm="12" cols="12" class="form-field-column">
                    <label class="display-field-label mb-2">{{ $t('Grouping.itemsubgroup') }}</label>
                </b-col>
                <b-col lg="12" md="12" sm="12" cols="12" class="form-field-column mb-5">
                    <span class="details-circle-common"> {{ dataObj.ItemSubGroupName }}</span>
                </b-col>
            </b-row>
        </b-col>
    </b-row>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
export default defineComponent({
    props: {
        dataObj: {
            type: Object,
            default: {}
        }
    },
    setup() {
        return {

        }
    }

})
</script>

<style lang="scss">
.details-circle-common {
    border-radius: 20px;
    background-color: #FEECDE;
    min-width: 300px;
    width: auto;
    padding-left: 4px;
    padding-right: 9px;
    padding-bottom: 9px;
    padding-top: 9px;
    margin-right: 20px;
}
</style>